import { link } from "fs";

export function computeHovered(nodes, links, hoveredNode, innerWidth) {
  let hoveredNodes = [];
  let hoveredLinks = [];

  if (!hoveredNode) {
    return {nodes: hoveredNodes, links: hoveredLinks};
  }


  let left = true;
  if (hoveredNode.x0 > innerWidth*0.5) {
    left = false;
  }

  let nodesToConsider = [hoveredNode];

  for (var iteration = 0; iteration < 3; iteration++) {
    hoveredNodes = [];
    hoveredLinks = [];

    for (var i = 0; i < links.length; i++) {
      let link = links[i];

      if (left) {
        if (nodesToConsider.indexOf(link.source) >= 0) {
          hoveredLinks.push(links[i]);
          if (link.target.x0 < innerWidth * 0.5) {
            nodesToConsider.push(link.target);
          } else {
            hoveredNodes.push(link.target);
          }
        }
      } else {
        if (nodesToConsider.indexOf(link.target) >= 0) {
          hoveredLinks.push(links[i]);
          if (link.source.x0 > innerWidth * 0.5) {
            nodesToConsider.push(link.source);
          } else {
            hoveredNodes.push(link.source);
          }
        }
      }
    }
  }

  hoveredNodes = hoveredNodes.concat(nodesToConsider);
  hoveredNodes = Array.from(new Set(hoveredNodes));

  return {
    nodes: hoveredNodes,
    links: hoveredLinks
  };
};



// WEBPACK FOOTER //
// ./src/Sankey/computeHovered.js